function triggerBeeDatalayers() {
  
    // Triggers when a visitor sees a campaign
    document.addEventListener('onTriggerbeeWidgetOpened', function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'onTriggerbeeWidgetOpened',
            'campaignName': event.detail.campaignName,
            'campaignId': event.detail.campaignId,
            'variantId': event.detail.id,
        });
    });

    // Triggers when a visitor closes a campaign
    document.addEventListener('onTriggerbeeWidgetClosed', function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'onTriggerbeeWidgetClosed',
            'campaignName': event.detail.campaignName,
            'campaignId': event.detail.campaignId,
            'variantId': event.detail.id,
        });
    });

    // Triggers when a visitor submits a form in a campaign, but before the submit has actually happened
    document.addEventListener('onBeforeTriggerbeeFormSubmitted', function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'onBeforeTriggerbeeFormSubmitted',
            'campaignName': event.detail.campaignName,
            'campaignId': event.detail.campaignId,
            'variantId': event.detail.id,
        });
    });

    // Triggers when a visitor submits a form in a campaign, after the submit is successful
    document.addEventListener('onAfterTriggerbeeFormSubmitted', function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'onAfterTriggerbeeFormSubmitted',
            'campaignName': event.detail.campaignName,
            'campaignId': event.detail.campaignId,
            'variantId': event.detail.id,
        });
    });

    // Triggers when a visitor clicks a button in a campaign (not close buttons)
    document.addEventListener('onTriggerbeeWidgetButtonClicked', function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'onTriggerbeeWidgetButtonClicked',
            'campaignName': event.detail.campaignName,
            'campaignId': event.detail.campaignId,
            'variantId': event.detail.id,
            'url': event.detail.url,
        });
    });
    // Triggers when the campaign switches state, eg. between primary and success state
    document.addEventListener('onTriggerbeeWidgetStateSwitched', function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'onTriggerbeeWidgetStateSwitched',
            'campaignName': event.detail.campaignName,
            'campaignId': event.detail.campaignId,
            'variantId': event.detail.id,
            'stateId': event.detail.stateId,
        });
    });

    $(window).on('mediaconnect:profile_loaded', function() {
        var products = getCookieValue('_mc_products');
        var hasSubscription = products != '' ? true : false;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'triggerbeeProfileLoaded',
            'email': window.mediaconnect_profile.email,
            'firstName': window.mediaconnect_profile.firstName,
            'lastName': window.mediaconnect_profile.lastName,
            'phoneNumber': window.mediaconnect_profile.phoneNumber,
            'hasSubscription': hasSubscription,
            'products': products,
        });
    });
}

function getCookieValue(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

export default function() {
    triggerBeeDatalayers();
}



// WEBPACK FOOTER //
// ./scripts/components/trigger-bee-data-layer.js